// === Accessibility Fixes for Product Items, Logo List, and 360 Images ===
(function () {
  const FOCUSABLE = 'a, button, input, select, textarea';

  // 🧠 Track keyboard vs mouse for custom focus styling
  function handleFirstTab(e) {
    if (e.key === 'Tab') {
      document.documentElement.classList.add('using-keyboard');
      document.documentElement.classList.remove('using-mouse');
    }
  }

  function handleMouseDown() {
    document.documentElement.classList.add('using-mouse');
    document.documentElement.classList.remove('using-keyboard');
  }

  window.addEventListener('keydown', handleFirstTab);
  window.addEventListener('mousedown', handleMouseDown);

  // ✅ Fix focusables inside product items
  function fixVisibleProductItems() {
    const items = document.querySelectorAll('.product-item');

    items.forEach(item => {
      const rect = item.getBoundingClientRect();
      const isVisible =
        rect.bottom > 0 &&
        rect.top < window.innerHeight &&
        rect.right > 0 &&
        rect.left < window.innerWidth;

      const isFocused = item.contains(document.activeElement);

      if (!isVisible && isFocused) {
        document.activeElement.blur();
      }

      item.querySelectorAll(FOCUSABLE).forEach(el => {
        if (isVisible) {
          el.removeAttribute('tabindex');
          el.removeAttribute('aria-disabled');
          el.removeAttribute('aria-hidden');
        } else {
          el.setAttribute('tabindex', '-1');
          el.setAttribute('aria-disabled', 'true');
          el.setAttribute('aria-hidden', 'true');
        }
      });

      // Mark item itself if necessary
      if (isVisible) {
        item.removeAttribute('aria-hidden');
        item.removeAttribute('tabindex');
        item.removeAttribute('aria-disabled');
      } else {
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
        item.setAttribute('aria-disabled', 'true');
      }
    });
  }

  // ✅ Fix collection items
  function fixVisibleCollectionItems() {
    const items = document.querySelectorAll('.collection-item');

    items.forEach(item => {
      const rect = item.getBoundingClientRect();
      const isVisible =
        rect.bottom > 0 &&
        rect.top < window.innerHeight &&
        rect.right > 0 &&
        rect.left < window.innerWidth;

      const isFocused = item.contains(document.activeElement);

      if (!isVisible && isFocused) {
        document.activeElement.blur();
      }

      if (isVisible) {
        item.removeAttribute('aria-hidden');
        item.removeAttribute('tabindex');
        item.removeAttribute('aria-disabled');
      } else {
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
        item.setAttribute('aria-disabled', 'true');
      }
    });
  }

  // ✅ Patch alt tags in 360 viewer
  function handleSpinStudioAltText() {
    const spinStudioSelectors = [
      'img[src*="spinstudio.myshopify.com"]',
      'img[id*="spin-studio"]',
      'img[class*="spin-studio"]'
    ].join(',');

    document.querySelectorAll(spinStudioSelectors).forEach(img => {
      const src = img.getAttribute('src')?.trim() || '';
      const isVisible = img.offsetParent !== null;

      if (!img.hasAttribute('alt')) {
        img.alt = src.includes('spinstudio.myshopify.com') && isVisible ? 'Spin Studio 360 Product Image' : '';
      }
    });
  }

  // ✅ Main runner
  function runAccessibilityFixes() {
    fixVisibleProductItems();
    fixVisibleCollectionItems();
  }

  // ✅ Watch DOM mutations
  let observerTimeout;
  const unifiedObserver = new MutationObserver(() => {
    clearTimeout(observerTimeout);
    observerTimeout = setTimeout(() => {
      runAccessibilityFixes();
      handleSpinStudioAltText();
      if (typeof syncAllToggles === 'function') syncAllToggles();
    }, 50);
  });

  unifiedObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-hidden', 'src', 'alt']
  });

  // ✅ Scroll event support
  function setupScrollListeners() {
    const containers = document.querySelectorAll('.product-list--scrollable, .scroller__inner');

    containers.forEach(container => {
      container.addEventListener('scroll', () => {
        requestAnimationFrame(() => {
          runAccessibilityFixes();
        });
      }, { passive: true });
    });
  }

  // ✅ On load
  window.addEventListener('load', () => {
    runAccessibilityFixes();
    handleSpinStudioAltText();
    setupScrollListeners();

    // 🔒 Kill focus on logo carousel
    document.querySelectorAll('.quick-links__link').forEach(link => {
      link.setAttribute('tabindex', '-1');
      link.setAttribute('aria-hidden', 'true');
      link.setAttribute('aria-disabled', 'true');
    });
  });

  // Failsafe DOMContentLoaded backup
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.quick-links__link').forEach(link => {
      link.setAttribute('tabindex', '-1');
      link.setAttribute('aria-hidden', 'true');
      link.setAttribute('aria-disabled', 'true');
    });
  });

  // 🧪 Expose fix function
  window.fixFocusableInCarousels = runAccessibilityFixes;
})();
